/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetSubmissionsReportParams = {
  user_id?: string | null;
  /**
   * Inclusive UTC cutoff on submissionDate (ISO-8601). Naive timestamps are treated as UTC. When either cutoff is set, sort is ignored and rows are oldest of that timestamp first. When both are set, a row must match both, ordered by submission date.
   */
  submittedSince?: string | null;
  /**
   * Inclusive UTC cutoff on correctionDate (ISO-8601). Naive timestamps are treated as UTC. When either cutoff is set, sort is ignored and rows are oldest of that timestamp first. When both are set, a row must match both, ordered by submission date.
   */
  gradedSince?: string | null;
  page?: number;
  pageSize?: number;
  sort?: string;
  filter?: string;
};
